import React from 'react';
import Slick from 'react-slick';
import _ from 'lodash';

export default function MobileCategoriesGrid({items}) {
  const slickOptions = {
    dots: true,
    slidesToShow: 1
  };
  const slides = _(items).map((item) => <div>{item}</div>)
  .chunk(3).map((_items) => <Slick {...slickOptions}>{_items}</Slick>).value();
  return (
    <div>
      {slides}
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/MainPage/elements/MobileCategoriesGrid.jsx
 **/